<template>
    <div class="MyDialog checkInDialog" :style="{'display': visible? 'block' : 'none'}">
        <div class="MyDialogMask"></div>
        <div class="MyDialogContent">
            <svg xmlns="http://www.w3.org/2000/svg"
                width="20" height="20" viewBox="0 0 20 20" fill="none" class="checkClose" @click="closeDialog()">
                <path d="M3.33301 3.33301L16.6663 16.6663" stroke="#fff" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M3.33301 16.6663L16.6663 3.33301" stroke="#fff" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <check-in-list :data="rewards" :dialog="true" @checkIn="onCheckIn"/>
        </div>
    </div>
</template>

<script>
import CheckInList from './CheckInList.vue';

export default {
    name: "CheckinReward",
    components: {
        CheckInList
    },
    data() {
        return {
            visible: false,
            rewards: {}
        };
    },
    methods: {
        onCheckIn(){
            this.$emit('checkIn');
            this.closeDialog();
        },
        showDialog(data){
            this.visible = true;
            data.dialog = true;
            this.rewards = data;
        },
        closeDialog(){
            this.visible = false;
        }
    }
}
</script>

<style lang="scss" scoped>

.MyDialog {
    font-size: 14px;
    color: #666;
    font-weight: 400;
    --color-primary: #557be1;
}

.MyDialog .MyDialogMask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6;
    width: 100%;
    height: 100%;
    opacity: .7;
    background: #000
}

.MyDialog .MyDialogIcon {
    position: absolute;
    top: 10px;
    right: 10px
}

.MyDialog .MyDialogTitle {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 24px;
    text-align: center
}

.MyDialog .MyDialogContent {
    max-width: 540px;
    padding: 24px 24px 32px;
    box-sizing: border-box;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 7;
    background-color: #fff;
    border-radius: 12px
}

.MyDialog .MyDialogText {
    padding: 0 32px;
    display: flex;
    justify-content: start;
    align-items: flex-start
}

.MyDialog .MyDialogText .el-icon-warning {
    color: #f90;
    font-size: 24px;
    margin-right: 3px
}

.MyDialog .MyDialogBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px
}

.MyDialog .MyDialogBtns button {
    border-radius: 6px;
    border: 1px solid #e6e6e6;
    background: #fff;
    color: #666;
    font-size: 14px;
    font-weight: 500;
    width: 130px;
    height: 44px
}

.MyDialog .MyDialogBtns .MyDialogBtn {
    margin-left: 10px;
    background: var(--color-primary);
    color: #fff
}

.welfareDialog .MyDialogContent {
    background: linear-gradient(180deg,#e5ecff -.05%,#fff 20.01%,#fff 100.24%);
    min-width: 560px;
    max-width: 560px
}

.bigImgWrap .MyDialogText {
    display: none
}

.bigImgWrap .MyDialogContent {
    background: 0 0;
    padding: 0;
    border-radius: 0;
    display: flex;
    justify-content: center
}

.bigImgWrap .MyDialogIcon {
    display: none
}

.ADialogValid .MyDialogText {
    padding: 0
}

.ADialog .MyDialogContent {
    background-image: url(data:image/webp;base64,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);
    background-repeat: no-repeat;
    background-position: top;
    background-size: 100% 100%;
    background-color: transparent;
    min-width: 465px;
    min-height: 417px;
    padding: 34px 50px
}

.checkInDialog .MyDialogContent {
    background: 0 0;
    padding: 10px 0
}

.popProduct .MyDialogContent {
    padding: 0;
    background: 0 0;
    width: 448px;
    max-height: 648px
}

@media(max-width: 767px) {
    .MyDialog .MyDialogContent {
        width:90vw;
        max-height: 66vh;
        overflow-y: scroll
    }

    .MyDialog .MyDialogText {
        padding: 0
    }

    .welfareDialog .MyDialogContent {
        min-width: auto
    }

    .ADialog .MyDialogContent {
        min-width: auto;
        max-width: 100%;
        padding: 18px;
        min-height: auto
    }

    .checkInDialog .MyDialogContent {
        background: 0 0;
        padding: 10px 0;
        width: 95vw;
        max-height: 88vh
    }

    .popProduct .MyDialogContent {
        width: 347px;
        max-height: 488px
    }
}

.checkClose {
    position: absolute;
    top: 30px;
    right: 15px;
    z-index: 1
}

</style>